import React, { useRef, useEffect, useState } from 'react';
import { DropDownStyle, ListDropDown, DropDownContainer, Label, SortIcon, SortTitle } from './Styled';

export interface DropDownProps {
  overflow?: 'hidden' | 'visible';
  children: JSX.Element;
  left?: string;
  top?: string;
  label?: string;
  oneClick?: boolean;
  clickOutsideClose?: boolean;
}

const DropDown = (props: DropDownProps) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef<any>(null);
  const { clickOutsideClose, oneClick, children, left, top, label, overflow } = props;

  const toggleDropDown = React.useCallback(() => setVisible(!visible), [visible]);

  useEffect(() => {
    const handleAfterClick = (e: any) => {
      const clickInsideDropdown = !!ref.current === e.target.closest('.show-dropdown');

      if (clickOutsideClose && !clickInsideDropdown) {
        toggleDropDown();
      }
      if (oneClick && clickInsideDropdown) {
        toggleDropDown();
      }
    };

    if (visible) {
      document.addEventListener('click', handleAfterClick);
    }

    return () => {
      document.removeEventListener('click', handleAfterClick);
    };
  }, [ref, visible, toggleDropDown]);

  const buildRender = () => (
    <DropDownStyle>
      <DropDownContainer>
        <button onClick={toggleDropDown} type="button">
          <SortIcon />
          <SortTitle>ordenar</SortTitle>
          <Label>{label}</Label>
        </button>
        <ListDropDown ref={ref} className={visible ? 'show-dropdown' : ''} theme={{ visible, left, top, overflow }}>
          {children}
        </ListDropDown>
      </DropDownContainer>
    </DropDownStyle>
  );

  return buildRender();
};

DropDown.defaultProps = {
  left: 'initial',
  top: '50px',
  right: '0',
  bottom: 'initial',
  children: <></>,
  label: '',
  overflow: 'hidden',
  oneClick: false,
  clickOutsideClose: true,
  ellipsis: false,
};

export default DropDown;
export { DropDown };
